import Nullstack from 'nullstack';
export default function IconRobot({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-robot",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"
  }), "   ", Nullstack.element("path", {
    d: "M10 16h4"
  }), "   ", Nullstack.element("circle", {
    cx: "8.5",
    cy: "11.5",
    r: ".5",
    fill: "currentColor"
  }), "   ", Nullstack.element("circle", {
    cx: "15.5",
    cy: "11.5",
    r: ".5",
    fill: "currentColor"
  }), "   ", Nullstack.element("path", {
    d: "M9 7l-1 -4"
  }), "   ", Nullstack.element("path", {
    d: "M15 7l1 -4"
  }), " ");
}